import type { IconSvgObject } from './types';

const NextIcon: IconSvgObject = [
  ["path", { d: "M5.5241 19.0621C4.85783 19.4721 4 18.9928 4 18.2104V5.78956C4 5.00724 4.85783 4.52789 5.5241 4.93791L15.6161 11.1483C16.2506 11.5388 16.2506 12.4612 15.6161 12.8517L5.5241 19.0621Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 4.5L20 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default NextIcon;
